import React from "react";
import { Receipt, Users, RefreshCw, AlertTriangle } from "lucide-react";
import { eur } from "../../lib/salaApi";

// "Incasso servizio" strip fed by Cassa in Cloud receipts (bills/receipts ingested server-side).
export function CassaSummary({ data, services, service, loading, onSync, compact = false }) {
  if (!data) return null;
  if (data.configured === false) {
    return <div className="rounded-2xl border border-dashed border-[#e8dcc8] bg-white/70 px-3 py-2 text-xs text-[#7c5a4e] inline-flex items-center gap-2" data-testid="cassa-not-configured"><AlertTriangle className="h-3.5 w-3.5" /> Cassa in Cloud non collegata</div>;
  }
  const keys = service && service !== "all" ? [service] : Object.keys(services || {});
  const cells = keys.map((k) => ({ key: k, label: services?.[k]?.label || k, ...(data.services?.[k] || { receipts: 0, covers: 0, amount: 0 }) }));
  const tot = keys.length > 1 ? data.total : null;
  if (compact) {
    return (
      <div className="rounded-full border border-[#e8dcc8] bg-white px-3 py-1.5 flex items-center gap-2 overflow-x-auto no-scrollbar" data-testid="cassa-summary">
        <Receipt className="h-4 w-4 text-[#C48B31] shrink-0" />
        <span className="text-[11px] font-bold uppercase tracking-wide text-[#7c5a4e] shrink-0">Incasso</span>
        {data.error && <span className="text-[11px] text-rose-700 truncate" data-testid="cassa-error" title={data.error}>errore cassa</span>}
        {cells.map((c) => (
          <span key={c.key} className="shrink-0 inline-flex items-center gap-1.5 rounded-full bg-[#faf3ee] px-2.5 py-0.5 text-sm" data-testid={`cassa-cell-${c.key}`}>
            <span className="text-[10px] uppercase tracking-wide text-[#7c5a4e]">{c.label}</span><b className="text-[#2b1410]">{eur(c.amount)}</b>
            <span className="text-[11px] text-[#7c5a4e] inline-flex items-center gap-0.5"><Receipt className="h-3 w-3" />{c.receipts}</span>
            <span className="text-[11px] text-[#7c5a4e] inline-flex items-center gap-0.5"><Users className="h-3 w-3" />{c.covers}</span>
          </span>
        ))}
        {tot && <span className="shrink-0 inline-flex items-center gap-1.5 rounded-full bg-[#4a1c17] text-white px-2.5 py-0.5 text-sm" data-testid="cassa-cell-total"><span className="text-[10px] uppercase tracking-wide text-white/70">Totale</span><b>{eur(tot.amount)}</b><span className="text-[11px] text-white/80">{tot.covers} cop.</span></span>}
        <div className="flex-1" />
        {onSync && <button onClick={onSync} className="h-7 w-7 shrink-0 rounded-full hover:bg-[#faf3ee] flex items-center justify-center" title="Aggiorna dalla cassa" data-testid="cassa-sync-btn"><RefreshCw className={`h-3.5 w-3.5 ${loading ? "animate-spin" : ""}`} /></button>}
      </div>
    );
  }
  return (
    <div className="rounded-3xl border border-[#e8dcc8] bg-white p-3" data-testid="cassa-summary">
      <div className="flex items-center gap-2 mb-2">
        <Receipt className="h-4 w-4 text-[#C48B31]" />
        <span className="text-xs font-bold uppercase tracking-wide text-[#7c5a4e]">Incasso servizio · Cassa in Cloud</span>
        {data.error && <span className="text-[11px] text-rose-700 truncate" data-testid="cassa-error" title={data.error}>errore cassa</span>}
        <div className="flex-1" />
        {onSync && <button onClick={onSync} className="h-7 w-7 rounded-full hover:bg-[#faf3ee] flex items-center justify-center" title="Aggiorna dalla cassa" data-testid="cassa-sync-btn"><RefreshCw className={`h-3.5 w-3.5 ${loading ? "animate-spin" : ""}`} /></button>}
      </div>
      <div className={`grid gap-2 ${cells.length + (tot ? 1 : 0) >= 3 ? "grid-cols-3" : cells.length === 2 ? "grid-cols-2" : "grid-cols-1"}`}>
        {cells.map((c) => <Cell key={c.key} label={c.label} c={c} testId={`cassa-cell-${c.key}`} />)}
        {tot && <Cell label="Totale" c={tot} strong testId="cassa-cell-total" />}
      </div>
    </div>
  );
}

function Cell({ label, c, strong, testId }) {
  return (
    <div className={`rounded-2xl px-3 py-2 ${strong ? "bg-[#4a1c17] text-white" : "bg-[#faf3ee] text-[#2b1410]"}`} data-testid={testId}>
      <div className={`text-[10px] uppercase tracking-wide ${strong ? "text-white/70" : "text-[#7c5a4e]"}`}>{label}</div>
      <div className="text-lg sm:text-xl font-bold leading-tight">{eur(c.amount)}</div>
      <div className={`text-[11px] inline-flex items-center gap-2 ${strong ? "text-white/80" : "text-[#7c5a4e]"}`}>
        <span className="inline-flex items-center gap-0.5"><Receipt className="h-3 w-3" /> {c.receipts}</span>
        <span className="inline-flex items-center gap-0.5"><Users className="h-3 w-3" /> {c.covers}</span>
      </div>
    </div>
  );
}
